import React from 'react';
import locales from '../../locales/LocalesManager';
import properties from '../../constants/Properties';
import appParameters from '../../components/utils/AppParameters';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import resumeSessionUtils from '../utils/ResumeSessionUtils';

const LostSessionAlertContent = React.createClass({
    onClose(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        apiServiceUtils.showLostSessionAlert(false);
    },
    checkApp() {
        // added for NCA-101
        if (platformDetection.isIOSApp() && this.props.showLostSessionAlert > 0 && this.props.showLostSessionAlert < 5) {
            resumeSessionUtils.resumeSession();
        }
    },
    getAlertMessage() {
        var alertMessage = locales.getCaption('LostSessionAlert', 'other');

        switch(this.props.showLostSessionAlert) {
            case 1: { // Lost sesssion ... default message
                alertMessage = locales.getCaption('LostSessionAlert', 'other');
                break;
            }

            case 2: { // Bad Json data
                alertMessage = locales.getCaption('BadDataAlert', 'other');
                break;
            }

            case 3: { // Exception during storing flow
                alertMessage = locales.getCaption('StoringServerErrorAlert', 'other');
                break;
            }

            case 4: { // Exception on storing success response
                alertMessage = locales.getCaption('StoringBadResponseAlert', 'other');
                break;
            }
        }

        return alertMessage;
    },
    isVisible() {
        if (platformDetection.isIOSApp())
            return false;

        if (this.props.showLostSessionAlert > 0 && this.props.showLostSessionAlert < 5) // 5 is for NoInternetConnection
            return true;
        else
            return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.showLostSessionAlert != newProps.showLostSessionAlert || this.props.windowHeight != newProps.windowHeight || this.props.windowWidth != newProps.windowWidth)
            return true;
        else
            return false;
    },
    render() {
        this.checkApp();

        var visible = 'none';

        if (this.isVisible())
            visible = 'block';
        else
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            userSelect: 'none',
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: properties.DELETE_ALERT_BACKGROUND_OPACITY
        };

        var alertHeight = 250;
        const alertHolderStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT / 2,
            left: this.props.windowWidth / 2 - properties.DELETE_ALERT_WIDTH / 2,
            width: properties.DELETE_ALERT_WIDTH,
            height: alertHeight,
            backgroundColor: 'white',
            border: 3,
            borderStyle: 'solid',
            borderWidth: 10,
            borderColor: 'darkslategrey'
        };

        const spanStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 25,
            fontSize: 16,
            fontStyle: 'italic',
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            height: alertHeight- 2 * properties.DELETE_ALERT_BUTTON_GAP,
            cursor: 'default',
            color: 'black',
            whiteSpace: 'pre-line',
            textAlign: 'center'
        };

        const cancelStyle = {
            position: 'absolute',
            left: 3 * properties.DELETE_ALERT_BUTTON_GAP,
            top: alertHeight - 40,
            fontSize: 16,
            fontWeight: 'bold',
            width: properties.DELETE_ALERT_WIDTH - 6 * properties.DELETE_ALERT_BUTTON_GAP,
            height: 30,
            color: 'chocolate',
            whiteSpace: 'pre-line',
            textAlign: 'center',
            cursor: 'pointer',
            background: 'none',
            borderStyle: 'none'
        };

        const iconStyle = {
            position: 'absolute',
            width: 60,
            height: 60,
            left: properties.DELETE_ALERT_WIDTH / 2 - 30,
            top: alertHeight - 115
        };

        var alertMessage = this.getAlertMessage();

        return (
            <div style={menuStyle} id="lostSessionAlert">
                <div style={backgroundStyle}/>
                <div style={alertHolderStyle}>
                    <div style={spanStyle}>{alertMessage}</div>
                    <img alt='' aria-hidden='true' style={iconStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/error.png'}/>

                    <button id="lostSessionAlertButton" aria-label={locales.getCaption('Continue', 'other')} style={cancelStyle} onTouchEnd={this.onClose} onClick={this.onClose}>{locales.getCaption('Continue', 'other')}</button>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const showLostSessionAlert = state.menu.showLostSessionAlert;

    return {
        showLostSessionAlert
    };
}

export const LostSessionAlert = connect(mapStateToProps)(LostSessionAlertContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/LostSessionAlert.js
 **/